import ServiceBase from "./service-base";
import IHttpResponse from "src/http/http-response";
import { ServiceInjectable } from "src/utils/services";

/**
 * 通讯服务类
 * @class
 * @version 1.0.0
 */
@ServiceInjectable()
export default class LogService extends ServiceBase {
    /**
     * 分页获取异常日志
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async getExLogPage(data: any): Promise<IHttpResponse> {
        return await this.apis.getExLogPage({ data });
    }

    /**
     * 分页获取操作日志
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async getOpLogPage(data: any): Promise<IHttpResponse> {
        return await this.apis.getOpLogPage({ data });
    }

    /**
     * 分页获取访问日志
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async getVisLogPage(data: any): Promise<IHttpResponse> {
        return await this.apis.getVisLogPage({ data });
    }
}